import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-salesforce',
  templateUrl: './salesforce.component.html',
  styleUrls: ['./salesforce.component.scss']
})
export class SalesforceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
